import Box from '@redbubble/design-system/src/Box';
import Button from '@redbubble/design-system/src/Button';
import Card, { CardBody } from '@redbubble/design-system/src/Card';
import * as constants from '@redbubble/design-system/src/constants';
import Stack from '@redbubble/design-system/src/Stack';
import Text from '@redbubble/design-system/src/Text';
import TextLink from '@redbubble/design-system/src/TextLink';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import React from 'react';
export interface SignUpProps {
  loginLink: string;
  signUpLink: string;
}

export const messages = defineMessages({
  signUpButton: {
    defaultMessage: 'Sign Up',
  },
  signUpOffer: {
    defaultMessage: 'Get 25% off your first order',
  },
  loginLink: {
    defaultMessage: 'Log in',
  },
  loginText: {
    defaultMessage: 'to see if you have any member offers waiting for you.',
  },
});

export const SignUp = ({ loginLink, signUpLink }: SignUpProps) => {
  const intl = useIntl();

  const onLogin = () => {
    return true; // follow the href
  };

  const onSignUp = () => {
    return true; // follow the href
  };

  return (
    <>
      <Box marginBottom="m">
        <Card>
          <CardBody>
            <Stack
              direction={constants.HORIZONTAL}
              justifyContent="space-between"
              alignItems="center"
              padding="none"
            >
              <Text type="display6">
                <strong>{intl.formatMessage(messages.signUpOffer)}</strong>
              </Text>
              <Button
                intent={constants.PRIMARY}
                size={constants.SMALL}
                strong
                fluid
                href={signUpLink}
                onClick={onSignUp}
                role="link"
              >
                {intl.formatMessage(messages.signUpButton)}
              </Button>
            </Stack>
          </CardBody>
        </Card>
      </Box>
      <Text display="block" element="p">
        <TextLink
          href={loginLink}
          onClick={onLogin}
          intent={constants.PRIMARY}
          role="link"
        >
          {intl.formatMessage(messages.loginLink)}
        </TextLink>
        &nbsp; {intl.formatMessage(messages.loginText)}
      </Text>
    </>
  );
};
